import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { queryKeys } from '@/core/data-fetching/queryKeys';
import { whatsappPricingService } from '../api/whatsapp-pricing.service';

export function useWhatsAppPricing() {
  const client = useQueryClient();
  const query = useQuery({ queryKey: queryKeys.whatsappPricing, queryFn: whatsappPricingService.get });
  const importPricing = useMutation({
    mutationFn: whatsappPricingService.import,
    onSuccess: (data) => client.setQueryData(queryKeys.whatsappPricing, data),
  });
  return { query, importPricing };
}
